/**
 * API Configuration with Environment Detection
 * Automatically detects preview vs production environment
 * and returns the correct backend URL
 */

const getBackendUrl = () => {
  // Check if we're in browser environment
  if (typeof window === 'undefined') {
    if (process.env.REACT_APP_BACKEND_URL) return process.env.REACT_APP_BACKEND_URL;
    if (process.env.NODE_ENV !== 'production') return 'http://localhost:8001';
    throw new Error('Missing REACT_APP_BACKEND_URL: configure the API origin at build time.');
  }

  const hostname = window.location.hostname;
  
  // If running on preview domain, use preview backend
  if (hostname.includes('preview.emergentagent.com')) {
    return 'https://autocs-ai.preview.emergentagent.com';
  }
  
  // If running on localhost for development
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';
  }
  
  // For production / Azure: use the build-time REACT_APP_BACKEND_URL
  // (frontend on Static Web App ≠ backend on App Service — different domains)
  if (process.env.REACT_APP_BACKEND_URL) {
    return process.env.REACT_APP_BACKEND_URL;
  }

  throw new Error('Missing REACT_APP_BACKEND_URL: configure the API origin at build time.');
};

export const API_CONFIG = {
  BACKEND_URL: getBackendUrl()
};

export default API_CONFIG;
